/** 
* @name: ui-table 
* @Description: 表格展示 
* @Author: liulinmei 
* @Date: 2021-12-13 12:28:46
*/
<template>
  <el-table
    class="ui-table"
    :border="border"
    v-loading="loading"
    :data="tableData"
    :row-class-name="rowClassname"
    :row-style="rowStyle"
    @selection-change="changeSelection"
    @expand-change="expandChange"
  >
    <template slot="empty">
      <p v-if="emptyType === 'text' && !loading">{{ emptyText }}</p>
      <ui-empty
        v-if="emptyType === 'image' && !loading"
        :height="emptyHeight"
        :imgHeight="emptyImageHeight"
      ></ui-empty>
    </template>
    <template v-for="(item, index) in tableColumn">
      <!-- 索引列 -->
      <el-table-column
        v-if="item.type == 'index'"
        :key="'%' + index"
        type="index"
        :label="item.label"
        :width="item.width"
        :align="item.align"
        :fixed="item.fixed"
      />
      <!-- 选择列 -->
      <el-table-column
        v-else-if="item.type == 'selection'"
        :key="'%' + index"
        type="selection"
        :width="item.width"
        :align="item.align"
        :fixed="item.fixed"
      />
      <!-- 列表展开行 -->
      <el-table-column
        v-else-if="item.type == 'expand'"
        :key="'%' + index"
        type="expand"
      >
        <template slot-scope="props">
          <slot name="expand" :row="props.row"></slot>
        </template>
      </el-table-column>
      <!-- 此列需要自定义 -->
      <el-table-column
        v-else-if="item.slot"
        :key="'%' + index"
        :prop="item.prop"
        :label="item.label"
        :width="item.width"
        :align="item.align"
        :fixed="item.fixed"
        :formatter="item.formatter"
        :show-overflow-tooltip="item.showTooltip"
        :header-align="item.headerAlign"
        :class-name="item.className"
        :label-class-name="item.labelClassName"
      >
        <template slot-scope="{ row }">
          <slot :name="item.prop" :row="row"></slot>
        </template>
      </el-table-column>
      <!-- 正常列 -->
      <el-table-column
        v-else
        :key="'%' + index"
        :prop="item.prop"
        :label="item.label"
        :width="item.width"
        :align="item.align"
        :fixed="item.fixed"
        :formatter="item.formatter"
        :show-overflow-tooltip="item.showTooltip"
        :header-align="item.headerAlign"
        :class-name="item.className"
        :label-class-name="item.labelClassName"
      >
      </el-table-column>
    </template>
  </el-table>
</template>

<script>
export default {
  name: 'ui-table',
  components: {
    'ui-empty': () => import('@/components/ui-components/empty/ui-empty.vue'),
  },
  props: {
    border: {
      type: Boolean,
      default: false,
    },
    // 表格展示数据
    tableColumn: {
      type: Array,
      default: () => [],
    },
    // 表格数据
    tableData: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    rowClassname: {
      //	行的 className 的回调方法，也可以使用字符串为所有行设置一个固定的 className。
      type: [String, Function],
    },
    rowStyle: {
      //行的 style 的回调方法，也可以使用一个固定的 Object 为所有行设置一样的 Style。
      type: [String, Function],
    },
    emptyType: {
      //空数据时显示的文本内容类型
      type: String,
      default: 'text',
    },
    emptyText: {
      //空数据时显示的文本内容类型
      type: String,
      default: '暂无数据',
    },
    emptyImageHeight: {
      //空数据时显示的省略图的高度
      type: Number,
    },
    emptyHeight: {
      //空数据时显示缺省图容器的高度
      type: Number,
    },
  },
  methods: {
    // 改变选中行的回调
    changeSelection(val) {
      this.$emit('changeSelection', val)
    },
    expandChange(row, val) {
      this.$emit('expandChange', row, val)
    },
  },
}
</script>

<style lang="scss" scoped>
.ui-table {
  border: 1px solid #e4e7ed;
  border-bottom: none;
  /deep/ .el-table__cell {
    padding: 10px 0;
    color: #666;
  }
  /deep/ th.el-table__cell {
    color: #333;
    font-weight: bold;
    background-color: #fafafa;
  }
}
</style>
